<mat-expansion-panel
  class="box-shadow border-radius-0"
  (afterExpand)="onExpand()"
  #panel
>
  <mat-expansion-panel-header>
    <mat-panel-title class="panel-header-title">
      <mat-icon [inline]="true" class="opacity-4">hail</mat-icon>
      <span>Load/Standby List</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div
      *ngIf="{
        load: load$ | async,
        standbyList: standbyList$ | async,
        jumpseaters: jumpseaters$ | async,
        jumpseaterContact: jumpseatContact$ | async,
        jumpseaterContactLoading: isJumpseatLoading$ | async,
        seatMap: seatMap$ | async
      } as vm"
    >
      <div
        *ngIf="
          vm.load?.response &&
          vm.load?.response?.text?.includes('FLIGHT NOT INITIALIZED')
        "
        class="text-sm text-center"
      >
        Flight not initialized
      </div>
      <div
        *ngIf="
          !vm.load?.isLoading &&
          !vm.standbyList?.isLoading &&
          (!vm.load?.response || !vm.standbyList?.response)
        "
        class="text-center text-sm"
      >
        Load/standbys unavailable
      </div>
      <div
        *ngIf="
          vm.load?.response &&
          vm.standbyList?.response &&
          !vm.load?.response?.text?.includes('FLIGHT NOT INITIALIZED')
        "
      >
        <app-data-box
          headerTitle="Passenger Load"
          [isLoading]="vm.load?.isLoading && !vm.load?.response"
          class="mt-16"
        >
          <div class="data-box-content">
            <div *ngIf="vm.load?.response">
              <table>
                <tr>
                  <td></td>
                  <td class="text-xs opacity-4 text-right pl-16">
                    Booked/Auth
                  </td>
                  <td class="text-xs opacity-4 text-right pl-16">Avail</td>
                </tr>
                <tr *ngIf="vm.load?.response?.auth?.first">
                  <td class="accent-color text-base">First</td>
                  <td class="value-3 text-right">
                    {{ vm.load?.response?.booked?.first }}/{{
                      vm.load?.response?.auth?.first
                    }}
                  </td>
                  <td
                    class="value-3 text-right"
                    [class.success-color]="
                      vm.load?.response?.avail?.first &&
                      vm.load?.response?.avail?.first! > 0
                    "
                    [class.caution-color]="
                      vm.load?.response?.avail?.first == undefined &&
                      vm.load?.response?.avail?.first === 0
                    "
                    [class.warn-color]="
                      vm.load?.response?.avail?.first &&
                      vm.load?.response?.avail?.first! < 0
                    "
                  >
                    {{ vm.load?.response?.avail?.first }}
                  </td>
                </tr>
                <tr *ngIf="vm.load?.response?.auth?.business">
                  <td class="accent-color text-base">Business</td>
                  <td class="value-3 text-right">
                    {{ vm.load?.response?.booked?.business }}/{{
                      vm.load?.response?.auth?.business
                    }}
                  </td>
                  <td
                    class="value-3 text-right"
                    [class.success-color]="
                      vm.load?.response?.avail?.business &&
                      vm.load?.response?.avail?.business! > 0
                    "
                    [class.caution-color]="
                      vm.load?.response?.avail?.business == undefined &&
                      vm.load?.response?.avail?.business === 0
                    "
                    [class.warn-color]="
                      vm.load?.response?.avail?.business &&
                      vm.load?.response?.avail?.business! < 0
                    "
                  >
                    {{ vm.load?.response?.avail?.business }}
                  </td>
                </tr>
                <tr *ngIf="vm.load?.response?.auth?.premEcon">
                  <td class="accent-color text-base">Prem Econ</td>
                  <td class="value-3 text-right">
                    {{ vm.load?.response?.booked?.premEcon }}/{{
                      vm.load?.response?.auth?.premEcon
                    }}
                  </td>
                  <td
                    class="value-3 text-right"
                    [class.success-color]="
                      vm.load?.response?.avail?.premEcon &&
                      vm.load?.response?.avail?.premEcon! > 0
                    "
                    [class.caution-color]="
                      vm.load?.response?.avail?.premEcon == undefined &&
                      vm.load?.response?.avail?.premEcon === 0
                    "
                    [class.warn-color]="
                      vm.load?.response?.avail?.premEcon &&
                      vm.load?.response?.avail?.premEcon! < 0
                    "
                  >
                    {{ vm.load?.response?.avail?.premEcon }}
                  </td>
                </tr>
                <tr *ngIf="vm.load?.response?.auth?.main">
                  <td class="accent-color text-base">Main</td>
                  <td class="value-3 text-right">
                    {{ vm.load?.response?.booked?.main }}/{{
                      vm.load?.response?.auth?.main
                    }}
                  </td>
                  <td
                    class="value-3 text-right"
                    [class.success-color]="
                      vm.load?.response?.avail?.main &&
                      vm.load?.response?.avail?.main! > 0
                    "
                    [class.caution-color]="
                      vm.load?.response?.avail?.main == undefined &&
                      vm.load?.response?.avail?.main === 0
                    "
                    [class.warn-color]="
                      vm.load?.response?.avail?.main &&
                      vm.load?.response?.avail?.main! < 0
                    "
                  >
                    {{ vm.load?.response?.avail?.main }}
                  </td>
                </tr>
                <tr *ngIf="vm.load?.response?.auth?.total">
                  <td class="accent-color text-base font-bold">Total</td>
                  <td class="text-base text-right font-bold">
                    {{ vm.load?.response?.booked?.total }}/{{
                      vm.load?.response?.auth?.total
                    }}
                  </td>
                  <td
                    class="text-base text-right font-bold"
                    [class.success-color]="
                      vm.load?.response?.avail?.total &&
                      vm.load?.response?.avail?.total! > 0
                    "
                    [class.caution-color]="
                      vm.load?.response?.avail?.total == undefined &&
                      vm.load?.response?.avail?.total === 0
                    "
                    [class.warn-color]="
                      vm.load?.response?.avail?.total &&
                      vm.load?.response?.avail?.total! < 0
                    "
                  >
                    {{ vm.load?.response?.avail?.total }}
                  </td>
                </tr>
              </table>
              <div class="flex-around">
                <button
                  mat-stroked-button
                  color="primary"
                  class="mt-16 stroked-btn"
                  (click)="
                    onViewTextClick(
                      vm.load?.response?.text || '',
                      vm.load?.response?.timestamp!
                    )
                  "
                  onclick="this.blur()"
                >
                  Sabre Text
                </button>
                <button
                  mat-stroked-button
                  color="primary"
                  class="mt-16 stroked-btn"
                  (click)="onSeatMapClick()"
                  onclick="this.blur()"
                >
                  Seat Map
                </button>
              </div>
            </div>
          </div>
        </app-data-box>
        <app-data-box
          headerTitle="Jumpseats In Use"
          [dataItems]="vm.load?.response?.jumpseatDataItems"
          [isLoading]="vm.load?.isLoading && !vm.load?.response"
          class="mt-32"
        >
        </app-data-box>
        <app-data-box
          headerTitle="AA Jumpseaters"
          class="mt-32"
          [isLoading]="isJumpseatLoading$ | async"
        >
          <div class="data-box-content">
            @if (vm.jumpseaters && vm.jumpseaters.length === 0) {
              <div class="text-center">None Listed</div>
            }
            @if (vm.jumpseaters && vm.jumpseaters.length > 0) {
              <table class="width-100 text-sm">
                <thead>
                  <th></th>
                  <th>Name</th>
                  <th class="pl-6">Seat</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr *ngFor="let jumpseater of vm.jumpseaters; let i = index">
                    <td class="text-xs opacity-4 text-right pr-4">
                      {{ i + 1 }}
                    </td>
                    <td>
                      <div [class.opacity-4]="!jumpseater.isCheckedIn">
                        {{ jumpseater.name | titlecase }}
                      </div>
                      <div class="text-xs opacity-4">
                        {{
                          jumpseater.listingDateTime.toFormat(
                            "MM/dd/yyyy HH:mm"
                          )
                        }}
                        CT
                      </div>
                    </td>
                    <td
                      class="pl-6"
                      [class.success-color]="jumpseater.seat?.includes('W')"
                    >
                      {{ jumpseater.seat }}
                    </td>
                    <td>
                      <div class="contact-btns">
                        <div *ngIf="jumpseater.history$ | async as history">
                          <button
                            mat-icon-button
                            color="primary"
                            (click)="onHistoryClick(jumpseater)"
                            [disabled]="history.isLoading"
                            tabindex="-1"
                            onclick="blur()"
                          >
                            <mat-spinner
                              *ngIf="history.isLoading"
                              diameter="24"
                            ></mat-spinner>
                            <mat-icon
                              *ngIf="history.response && !history.isLoading"
                              [class.success-color]="
                                history.response.items.length > 0
                              "
                              [class.warn-color]="
                                history.response.items.length === 0
                              "
                              [class.opacity-4]="
                                history.response.items.length === 0
                              "
                              >history</mat-icon
                            >
                            <mat-icon
                              *ngIf="!history.isLoading && !history.response"
                              class="warn-color"
                              >error_outline</mat-icon
                            >
                          </button>
                        </div>
                        <button
                          mat-icon-button
                          (click)="onContactClick(jumpseater, ContactType.Text)"
                          color="primary"
                          [disabled]="
                            contactIsLoading(jumpseater, ContactType.Text) ||
                            (connectionStatus$ | async) === 'offline'
                          "
                        >
                          @if (contactIsLoading(jumpseater, ContactType.Text)) {
                            <mat-spinner diameter="24"></mat-spinner>
                          } @else {
                            <mat-icon>sms</mat-icon>
                          }
                        </button>
                        <button
                          mat-icon-button
                          (click)="
                            onContactClick(jumpseater, ContactType.Phone)
                          "
                          color="primary"
                          [disabled]="
                            contactIsLoading(jumpseater, ContactType.Phone) ||
                            (connectionStatus$ | async) === 'offline'
                          "
                        >
                          @if (
                            contactIsLoading(jumpseater, ContactType.Phone)
                          ) {
                            <mat-spinner diameter="24"></mat-spinner>
                          } @else {
                            <mat-icon>phonelink_ring</mat-icon>
                          }
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-xs opacity-4 text-center width-100">
                Gray name indicates not checked in.
              </div>
            }
          </div>
        </app-data-box>
        <app-data-box
          headerTitle="Upgrade/Standby List"
          [helpComponent]="standbyListInfoComponent"
          [isLoading]="vm.standbyList?.isLoading && !vm.standbyList?.response"
          class="mt-32"
        >
          <div class="data-box-content">
            <ng-container *ngIf="vm.standbyList?.response as stbyList">
              <div *ngIf="stbyList.list.length === 0" class="p-16">None</div>
              <table
                class="width-100"
                *ngIf="stbyList.list.length > 0"
                [@tableAnimation]="stbyList.list.length"
              >
                <thead>
                  <th></th>
                  <th></th>
                  <th>Name</th>
                  <th>Prty</th>
                  <th>Seat</th>
                  <th>Rmk</th>
                </thead>
                <ng-container
                  *ngFor="
                    let passenger of stbyList.list;
                    index as i;
                    trackBy: trackByName
                  "
                >
                  <tr
                    class="text-xs"
                    [class.opacity-4]="
                      passenger.comment === 'NO ANS' &&
                      !passenger.isSeatAssigned
                    "
                    [class.font-bold]="
                      passenger.isAssignedFdJs || passenger.isListedFdJs
                    "
                    [class.caution-color]="
                      passenger.isListedFdJs &&
                      !passenger.isAssignedFdJs &&
                      !passenger.isSeatAssigned
                    "
                    [class.success-color]="passenger.isAssignedFdJs"
                  >
                    <td class="text-xs text-right opacity-4">{{ i + 1 }}</td>
                    <td>
                      <!-- row-height-set div is required for animation purposes -->
                      <div class="row-height-set flex-center">
                        <mat-icon
                          *ngIf="passenger.isSeatAssigned"
                          class="success-color icon-sm"
                          >task_alt</mat-icon
                        >
                      </div>
                    </td>
                    <td>
                      <div class="row-height-set">
                        {{ passenger.firstName | titlecase }}
                        {{ passenger.lastName | titlecase }}
                      </div>
                    </td>
                    <td>
                      <div class="row-height-set">
                        {{ passenger.priority }}
                      </div>
                    </td>
                    <td>
                      <div class="row-height-set">{{ passenger.seat }}</div>
                    </td>
                    <td class="opacity-6 text-xs">
                      <div class="row-height-set">{{ passenger.comment }}</div>
                    </td>
                  </tr>
                </ng-container>
              </table>
              <app-data-box headerTitle="" class="mt-16 width-100">
                <mat-radio-group
                  (change)="onListFilterChange($event)"
                  class="flex-around"
                >
                  <mat-radio-button
                    color="accent"
                    value="nonrev"
                    [checked]="(listFilter$ | async) === 'nonrev'"
                    >Non-rev</mat-radio-button
                  >
                  <mat-radio-button
                    color="accent"
                    value="stby"
                    [checked]="(listFilter$ | async) === 'stby'"
                    >Stby</mat-radio-button
                  >
                  <mat-radio-button
                    color="accent"
                    value="all"
                    [checked]="(listFilter$ | async) === 'all'"
                    >All</mat-radio-button
                  >
                </mat-radio-group>
              </app-data-box>
              <div class="flex-center">
                <button
                  mat-stroked-button
                  color="primary"
                  class="stroked-btn mt-16"
                  (click)="
                    onViewTextClick(stbyList.rawText, stbyList.timestamp)
                  "
                  onclick="this.blur()"
                >
                  Sabre Text
                </button>
              </div>
            </ng-container>
          </div>
        </app-data-box>
        <app-data-box
          headerTitle="Boarding Progress"
          [isLoading]="vm.load?.isLoading && !vm.load?.response"
          class="mt-32"
        >
          <div class="data-box-content">
            <div *ngIf="vm.load?.response">
              <div class="text-xs font-light opacity-4 text-center">
                Tickets scanned vs seats assigned
              </div>
              <mat-progress-bar
                color="accent"
                mode="determinate"
                [value]="
                  (vm.load?.response?.onBoard?.current! /
                    vm.load?.response?.onBoard?.total!) *
                  100
                "
                class="boarding-progress-bar"
              ></mat-progress-bar>
              <div class="value-3 text-center">
                {{ vm.load?.response?.onBoard?.current }}/{{
                  vm.load?.response?.onBoard?.total
                }}
              </div>
            </div>
          </div>
        </app-data-box>
      </div>
      <div class="data-status">
        <app-data-status
          [isLoading]="vm.standbyList?.isLoading"
          [timestamp]="vm.standbyList?.response?.timestamp"
          (refresh)="refresh()"
        ></app-data-status>
      </div>
      <mat-progress-bar
        *ngIf="vm.standbyList?.isLoading"
        class="progress-bar-bottom"
        color="accent"
        mode="indeterminate"
      ></mat-progress-bar>
    </div>
  </ng-template>
</mat-expansion-panel>
